import {
    VStack,
    HStack,
    Box,
    Text,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    Input,
    useDisclosure,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    Portal
} from "@chakra-ui/react";
import { ChevronDownIcon, CloseIcon, AddIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import { useState, useEffect } from "react";
import { useStores } from "../store/store_context";

const SelectBind = observer(({ report_name }) => {
    const { pageStore } = useStores();
    const [newBindName, setNewBindName] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleSave = () => {
        if (newBindName.trim()) {
            pageStore.saveBind(report_name, newBindName);
            setNewBindName("");
            onClose();
            pageStore.getReportBinds(report_name);
        }
    };

    useEffect(() => {
        pageStore.getReportBinds(report_name);
    }, []);

    return (
        <VStack
            borderRadius="10px"
            bg="rgb(51, 51, 51)"
            spacing={1}
            padding="6px"
            align="stretch"
            minW="220px"
        >
            <Text fontWeight="600" fontSize="11px" color="gray.400" textAlign="center" textTransform="uppercase">
                Сохр. настройки
            </Text>

            <HStack spacing={2}>
                <Menu isLazy>
                    <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        size="sm"
                        bg="#222"
                        color="#EEE"
                        variant="unstyled"
                        px={3}
                        borderRadius="8px"
                        fontSize="13px"
                        fontWeight="600"
                        _hover={{ bg: "#444" }}
                        _active={{ bg: "#000" }}
                        textAlign="left"
                        flex={1}
                        height="35px"
                    >
                        {pageStore.selectedBind || ""}
                    </MenuButton>
                    <Portal>
                        <MenuList bg="#1A1A1A" border="1px solid #444" zIndex={1500}>
                            {/* Сброс выбора */}
                            <MenuItem
                                bg="#1A1A1A"
                                color="gray.400"
                                fontSize="13px"
                                _hover={{ bg: "#333" }}
                                onClick={() => pageStore.updateSelectedBind(report_name, "")}
                            >
                                Сбросить (пусто)
                            </MenuItem>

                            {pageStore.report_binds.map((bind, index) => (
                                <MenuItem
                                    key={index}
                                    bg="#1A1A1A"
                                    _hover={{ bg: "#333" }}
                                    closeOnSelect={false}
                                >
                                    <HStack width="100%" justify="space-between">
                                        <Text
                                            flex={1}
                                            color="#EEE"
                                            fontSize="13px"
                                            onClick={() => {
                                                pageStore.updateSelectedBind(report_name, bind.bind_name);
                                            }}
                                        >
                                            {bind.bind_name}
                                        </Text>
                                        <IconButton
                                            icon={<CloseIcon size="xs" fontSize="8px" />}
                                            size="xs"
                                            variant="ghost"
                                            colorScheme="red"
                                            aria-label="Delete bind"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                pageStore.deleteBind(report_name, bind.bind_name);
                                                pageStore.getReportBinds(report_name);
                                            }}
                                        />
                                    </HStack>
                                </MenuItem>
                            ))}
                        </MenuList>
                    </Portal>
                </Menu>

                {/* ПОПОВЕР ДЛЯ СОХРАНЕНИЯ */}
                <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
                    <PopoverTrigger>
                        <IconButton
                            icon={<AddIcon />}
                            size="sm"
                            colorScheme="blue"
                            borderRadius="8px"
                            aria-label="Save current config"
                        />
                    </PopoverTrigger>
                    <PopoverContent bg="#333" borderColor="#444" color="white" boxShadow="xl">
                        <PopoverArrow bg="#333" />
                        <PopoverCloseButton />
                        <PopoverBody p={4}>
                            <VStack spacing={3}>
                                <Text fontSize="xs" fontWeight="bold">Название настройки:</Text>
                                <Input
                                    size="sm"
                                    value={newBindName}
                                    onChange={(e) => setNewBindName(e.target.value)}
                                    bg="#222"
                                    border="1px solid #555"
                                    _focus={{ borderColor: "blue.400" }}
                                />
                                <Button
                                    size="sm"
                                    colorScheme="blue"
                                    width="100%"
                                    onClick={handleSave}
                                    isDisabled={!newBindName.trim()}
                                >
                                    Сохранить
                                </Button>
                            </VStack>
                        </PopoverBody>
                    </PopoverContent>
                </Popover>
            </HStack>
        </VStack>
    );
});

export default SelectBind;